/**
 * Token 类型
 *
 * rtoken: 请求令牌 (request token)
 * utoken: 用户令牌 (user token)
 */
export enum TokenType {
  REQUEST_TOKEN = 'rtoken',
  USER_TOKEN = 'utoken',
}

/**
 * 资源枚举
 */
export enum ResourceType {
  /** 模块 */
  MODULE = '01',
  /** 菜单 */
  MENU = '02',
  /** 按钮 */
  BUTTON = '03',
  /** 网页 */
  PAGE = '04',
}

/**
 * 资源状态枚举
 */
export enum ResourceStatus {
  /** 启用 */
  ENABLED = '01',
  /** 禁用 */
  DISABLED = '02',
}

/**
 * 节点类型
 */
export enum NodeType {
  /** 非叶子节点 */
  NON_LEAF = 0,
  /** 叶子节点 */
  LEAF = 1,
}

/**
 * 角色类型
 */
export enum RoleType {
  /** 默认角色 */
  DEFAULT = '01',

  /** 普通角色 */
  NORMAL = '02',
}

/**
 * 启用/停用
 */
export enum EnableFlag {
  /** 无效 */
  DISABLED = 0,

  /** 有效 */
  ENABLED = 1,
}
